import { useState } from 'react'

export function useEntityPageProfileLayoutWidgetsHide({
  entityKey,
  initialWidgetsHidden = false,
  isAvailable,
}) {
  const [isHidden, setHidden] = useState(initialWidgetsHidden)
  const [hiddenStateEntityKey, setHiddenStateEntityKey] = useState(entityKey)

  if (hiddenStateEntityKey !== entityKey) {
    setHiddenStateEntityKey(entityKey)
    setHidden(initialWidgetsHidden)
  }

  const isWidgetsHidden = isAvailable && isHidden

  function handleToggleWidgetsHidden() {
    setHidden(currIsHidden => !currIsHidden)
  }

  return {
    isWidgetsHidden,
    widgetsHide: isAvailable
      ? { handleToggleWidgetsHidden, isWidgetsHidden }
      : null,
  }
}
